require('components/commons/wizardStep/wizardStep.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const throttle = require('lodash/function/throttle');
// @ helpers
const { formatText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
// @ components
const { OKButton } = require('components/commons/OKButton/OKButton');
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');
const OKModal = require('components/commons/OKModal/OKModal');

class WizardStep extends React.Component {
    constructor(props) {
        super(props);

        this.getFinishButton = this.getFinishButton.bind(this);
        this.getNextButton = this.getNextButton.bind(this);
        this.handlePrevClick = this.handlePrevClick.bind(this);
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);

        // Call click event only once during the period of one second. This prevents to accidentally trigger multiple calls of the same operation.
        this.handleFinishClick = throttle(
            this.handleFinishClick.bind(this),
            1000,
            { trailing: false },
        );

        this.state = {
            showModal: false,
        };
    }

    getCancelButton() {
        const { cancelButtonText } = this.props;
        const buttonText = cancelButtonText
            ? cancelButtonText
            : formatText('buttonsActions-cancel');
        const finalButtonText = toFirstUppercase(buttonText);

        return (
            <div className="wizard-step__first-button">
                <OKButton
                    modifier="link-ghost"
                    onClick={this.props.actions.handleCancelClick}
                >
                    {finalButtonText}
                </OKButton>
            </div>
        );
    }

    getFinishButton() {
        const {
            isLoading,
            addLoadingBehaviour,
            finalButtonModifier,
            finalButtonDisabled,
        } = this.props;
        const buttonText = formatText(this.props.immFinalButton);
        const CurrentButton =
            addLoadingBehaviour && !finalButtonDisabled
                ? SignaturePatternButton
                : OKButton;

        return (
            <div className="wizard-step__fourth-button">
                <CurrentButton
                    rightIcon={this.props.finalButtonIcon}
                    onClick={this.handleFinishClick}
                    loading={isLoading || this.props.isFetching}
                    modifier={finalButtonModifier}
                    disabled={finalButtonDisabled}
                >
                    {buttonText}
                </CurrentButton>
            </div>
        );
    }

    getGoBackButton() {
        const backText = toFirstUppercase(formatText('buttonsActions-goBack'));
        return (
            <div className="wizard-step__first-button">
                <OKButton
                    modifier="additional-action-secondary"
                    onClick={this.props.actions.handleGoBackClick}
                >
                    {backText}
                </OKButton>
            </div>
        );
    }

    getLeftCustomButton() {
        const leftCustomButton = this.props.leftCustomButton;

        return (
            <div className="wizard-step__first-button">{leftCustomButton}</div>
        );
    }

    getNextButton() {
        const {
            addLoadingBehaviour,
            isLoading,
            nextButtonDisabled,
            hasNextButtonText,
            nextButtonText,
        } = this.props;
        const buttonText = hasNextButtonText
            ? nextButtonText
            : toFirstUppercase(formatText('buttonsActions-next'));
        const CurrentButton = addLoadingBehaviour
            ? SignaturePatternButton
            : OKButton;

        return (
            <div className="wizard-step__third-button">
                <CurrentButton
                    modifier="secondary"
                    rightIcon="icon-siguiente"
                    onClick={this.props.actions.handleNextClick}
                    loading={isLoading}
                    disabled={nextButtonDisabled}
                >
                    {buttonText}
                </CurrentButton>
            </div>
        );
    }

    getPreviousButton() {
        const buttonText = toFirstUppercase(
            formatText('buttonsActions-previous'),
        );
        const {
            onBackClick,
            actions: { handlePrevClick },
        } = this.props;
        let onClick = handlePrevClick;

        if (onBackClick !== false) {
            onClick = () => {
                this.setState({
                    showModal: true,
                });
            };
        }

        return (
            <div className="wizard-step__second-button">
                <OKButton
                    modifier="ghost"
                    leftIcon="icon-anterior"
                    onClick={onClick}
                >
                    {buttonText}
                </OKButton>
            </div>
        );
    }

    buildButtonsSection() {
        const cancelButton = this.props.cancelButton
            ? this.getCancelButton()
            : null;
        const goBackButton = this.props.goBackButton
            ? this.getGoBackButton()
            : null;
        // A button with custom behaviour and styles that is placed on the bottom-left corner of the step.
        const leftCustomButton = this.props.leftCustomButton
            ? this.getLeftCustomButton()
            : null;
        let previousButton;
        let nextButton;
        let finishButton;

        switch (this.props.position) {
            case 'first':
                nextButton = this.getNextButton();
                break;
            case 'middle':
                previousButton = this.props.previousButton
                    ? this.getPreviousButton()
                    : null;
                nextButton = this.getNextButton();
                break;
            case 'last':
                previousButton = this.props.previousButton
                    ? this.getPreviousButton()
                    : null;
                finishButton = this.getFinishButton();
                break;
            default:
                nextButton = this.getNextButton();
                break;
        }

        return (
            <footer className="wizard-step__buttons">
                {goBackButton}
                {leftCustomButton}
                {cancelButton}
                {previousButton}
                {nextButton}
                {finishButton}
            </footer>
        );
    }

    handleFinishClick() {
        this.props.actions.handleFinishClick();
    }

    handleOnCloseModal() {
        this.setState({
            showModal: false,
        });
    }

    handlePrevClick() {
        const {
            confirmBackClick,
            actions: { handlePrevClick },
        } = this.props;
        this.setState({
            showModal: false,
        });
        confirmBackClick && confirmBackClick();
        handlePrevClick();
    }

    modalCustom() {
        const { confirmTitle, confirmDescription } = this.props;

        let component = null;
        if (confirmTitle) {
            component = (
                <OKModal
                    description={confirmDescription}
                    footerType="action"
                    isOpen={this.state.showModal}
                    onCloseCallback={this.handleOnCloseModal}
                    onPrimaryButtonClik={this.handlePrevClick}
                    onSecondaryButtonClick={this.handleOnCloseModal}
                    primaryButtonText="contractsView-checkingAccountStep4BackCloseButton"
                    secondaryButtonText="contractsView-checkingAccountStep4BackStayHereButton"
                    shouldCloseOnOverlayClick={false}
                    title={confirmTitle}
                />
            );
        }

        return component;
    }

    render() {
        const buttonsSection = this.buildButtonsSection();
        return (
            <article className="wizard-step">
                <section className="wizard-step__content">
                    {this.props.children}
                </section>
                {this.modalCustom()}
                {buttonsSection}
            </article>
        );
    }
}

WizardStep.propTypes = {
    actions: PropTypes.object,
    addLoadingBehaviour: PropTypes.bool,
    cancelButton: PropTypes.bool,
    leftCustomButton: PropTypes.object,
    goBackButton: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    confirmBackClick: PropTypes.func.isRequired,
    confirmDescription: PropTypes.string,
    confirmTitle: PropTypes.string,
    finalButtonIcon: PropTypes.string,
    immFinalButton: PropTypes.string,
    isFetching: PropTypes.bool,
    isLoading: PropTypes.bool,
    nextButtonDisabled: PropTypes.bool,
    finalButtonDisabled: PropTypes.bool,
    previousButton: PropTypes.bool,
    onBackClick: PropTypes.bool,
    position: PropTypes.oneOf(['first', 'middle', 'last']),
    cancelButtonText: PropTypes.string,
    finalButtonModifier: PropTypes.string,
    hasNextButtonText: PropTypes.bool,
    nextButtonText: PropTypes.string,
};

WizardStep.defaultProps = {
    addLoadingBehaviour: false,
    confirmBackClick: function() {},
    finalButtonIcon: '',
    isLoading: false,
    nextButtonDisabled: false,
    onBackClick: false,
    cancelButtonText: '',
};

module.exports = WizardStep;
